import React, { useState } from "react";
import { PrintRecord } from "../../../BlakeData/Types";
import DetailedMetadata from "./DetailedMetadata";
import FullImage from "./FullImage";
import { Button } from "../../Button";

import ViewerMicropalette from "./ViewerMicropalette";

import {ReactComponent as CompareIcon} from "./compare_nocolor.svg";
import {ReactComponent as QuantizeIcon} from "./eye_nocolor.svg";


// import ReactTooltip from 'react-tooltip';

import Measure, { ContentRect } from 'react-measure';

export function RightSide(props: {
    width: number;
    height: number;
    prints: Array<PrintRecord>;
    compareMode: boolean;
    quantizeMode: boolean;
    setQuantizeMode: (quantizeMode: boolean) => void;
    setCompareMode: (compareMode: boolean) => void;
}) {

    const [dimensions, setDimensions] = useState<{ width: number, height: number }>({ width: 0, height: 0 });
    const [imageWidth, setImageWidth] = useState<number>(0);

    // const [quantizeView, setQuantizeView] = useState<boolean>(false);

    let prints = props.prints;

    let previewMicropalettes = (null);

    if (!props.quantizeMode) {
        previewMicropalettes =
            <div
                style={{
                    position: "absolute",
                    bottom: "0px",
                    left: "0px"
                }}>
                <ViewerMicropalette
                    prints={prints}
                    side="left"
                    height={dimensions.height}
                    width={dimensions.width / prints.length}
                />
            </div>
    } 

    return (
        <div className="RightSide">

            <div className="image-preview-container">
                {previewMicropalettes}

                <div className="toggle-captions"></div>
                <DetailedMetadata
                    imageWidth={imageWidth}
                    width={dimensions.width}
                    prints={prints} />

                <Measure
                    bounds
                    onResize={(contentRect: ContentRect) => {
                        let { width, height } = contentRect.bounds || { width: 0, height: 0 };

                        setDimensions({
                            width,
                            height
                        });

                    }}
                >
                    {({ measureRef }) => (
                        <div className="image-preview" ref={measureRef}>
                            <FullImage
                                quantizeMode={props.quantizeMode}
                                setImageWidth={setImageWidth}
                                enableComparison={props.compareMode}
                                width={dimensions.width}
                                height={dimensions.height}
                                prints={prints} />
                        </div>
                    )}
                </Measure>


            </div>
            <div className="controls">
                <Button className={props.quantizeMode ? "toggled-on" : "toggle-off"}
                    text={<span>Quantize <span className="icon"><QuantizeIcon /></span></span>}
                    onClick={() => { props.setQuantizeMode(!props.quantizeMode) }}
                />
                <Button
                    className={props.compareMode ? "toggled-on" : "toggle-off"}
                    text={<span>Compare <span className="icon"><CompareIcon /></span></span>}
                    onClick={() => { props.setCompareMode(!props.compareMode) }}
                />
                {/* <div data-tip={"nudge!"}>?</div> */}
            </div>
            {/* <ReactTooltip event="click"/> */}

        </div>
    )

}